import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Tabs,
    Rate,
    Col,
    Popconfirm,
    message,
    Menu,
    Dropdown
} from 'antd';
import { Redirect, Link, withRouter } from 'react-router-dom';
import store from "../store/store.js";
import { PlusOutlined } from '@ant-design/icons'
import { PaperClipOutlined, LinkOutlined, DownOutlined, SearchOutlined, ReloadOutlined } from '@ant-design/icons'
import moment from 'moment';
import Edit from './edit.js'
import View from './view.js'
import HtView from '../hetong/view'
import { list } from 'postcss';


const { Option } = Select;
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newcondition: {},
            oldcondition: {},
            list: [],
            tableloading: false,
            selectedRowKeys: [],
            count: 0,
            type: '1'
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentWillMount() {
        this.props.GET_REFRESH(this.getdata)
    }

    componentDidMount() {
        // console.log(this.props)
        // let pathname = this.props.location.pathname
        this.props.NAV_CHANGE('/ztxm', ['首页', '在谈项目'])
        setTimeout(this.getdata(this.state.type, null))

    }

    onTimeChange(name, date, dateString) {
        let that = this
        console.log(name, date, dateString)
        let data = Object.assign({}, this.state.newcondition, { [name]: dateString })
        this.setState({
            newcondition: data
        })
    }

    onSelChange(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, { [name]: value })
        this.setState({
            newcondition: data
        })
    }
    onSelChange2(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition2, { [name]: value })
        this.setState({
            newcondition2: data
        })
    }

    arrsel(arr) {
        if (arr) {
            return arr.map((item, index) => <Option value={item.id} key={index}>{item.name}</Option>)
        }
    }

    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, { [name]: value })
        this.setState({
            newcondition: data
        })
    }

    onRangeChange(name, dates, dateStrings) {
        console.log(name, dates, dateStrings)
        var data = Object.assign({}, this.state.newcondition, {
            [name + '1']: dateStrings[0], [name + '2']: dateStrings[1]
        })
        if (data) {
            this.setState({
                newcondition: data
            })
        }
    }

    pagechange(page, pagesize) {
        let that = this
        console.log(page, pagesize)
        let data = Object.assign({}, this.state.oldcondition, { current: page, pagesize: pagesize })
        setTimeout(() => {
            this.setState({
                oldcondition: data
            })
            that.getdata(0, null)
        })
    }

    onSelectChange = selectedRowKeys => {
        console.log('selectedRowKeys changed: ', selectedRowKeys);
        this.setState({ selectedRowKeys });

        // 计算选中的 面积（亩）、面积（平米）、拟投资额
        let selected_mu = 0
        let selected_pingmi = 0
        let selected_price = 0
        const selectedItems = this.state.list.filter(item => selectedRowKeys.includes(item.id));
        selectedItems.map((item, index) => {
            if (item.mianji_unit == '平米') {
                selected_pingmi += Number(item.mianji)

            } else if (item.mianji_unit == '亩') {
                selected_mu += Number(item.mianji)
            }
            selected_price += Number(item.touzi_price)
        })
        this.setState({ selected_mu, selected_pingmi, selected_price });


    };

    onCheckboxChange(name, e) {
        let that = this
        let value = e.target.checked
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, { [name]: value })
        this.setState({
            newcondition: data
        })
    }

    getdata = (subtype = 0, e) => {
        let that = this
        that.setState({
            tableloading: true
        })
        if (subtype == 1) {
            var arr = that.state.newcondition
            let old = that.state.oldcondition
            arr = Object.assign({}, arr, { current: 1, pagesize: old.pagesize })
            that.setState({
                oldcondition: arr
            })
        } else {
            var arr = Object.assign({}, this.state.oldcondition, {})
        }
        arr.yuanqu = store.getState().data.yuanqu ? store.getState().data.yuanqu : null
        fetch('/ProjectResource/list', {
            // post提交
            method: "POST", body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 0) {
                    message.error(data.msg)
                    that.setState({
                        tableloading: false,
                    })
                    return
                }
                that.setState({
                    list: data.datalist,
                    capital_type_react: data.capital_type_react ? data.capital_type_react : [],
                    economic_type_react: data.economic_type_react ? data.economic_type_react : [],
                    industry_type_react: data.industry_type_react ? data.industry_type_react : [],
                    bumen_id_react: data.bumen_id_react ? data.bumen_id_react : [],
                    project_progress_react: data.project_progress_react ? data.project_progress_react : [],
                    project_tags_react: data.project_tags_react ? data.project_tags_react : [],
                    mianji_mu: data.extra.mianji_mu ? data.extra.mianji_mu : '',
                    mianji_pingmi: data.extra.mianji_pingmi ? data.extra.mianji_pingmi : '',
                    total_touzi_price: data.extra.total_touzi_price ? data.extra.total_touzi_price : '',
                    tableloading: false,
                    count: Number(data.count)
                })
            })
    }

    delSel() {
        let that = this
        fetch('/ProjectResource/delete', {
            method: "POST", body: JSON.stringify({
                'ids': this.state.selectedRowKeys,
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 0) {
                    message.error(data.msg)
                    return
                }
                this.pagechange(1, this.state.oldcondition.pagesize)
                that.setState({
                    selectedRowKeys: []
                })
            })
    }

    reset() {
        let that = this
        that.setState({
            newcondition: {}, oldcondition: {},
        })
        setTimeout(() => {
            that.getdata(1, null)
        })
    }

    download(type) {
        // type==1 下载选中部分
        let that = this
        that.setState({
            downloading: true
        })
        var arr = Object.assign({}, this.state.oldcondition, {})
        if (type == 1) {
            arr = {
                ids: that.state.selectedRowKeys
            }
        }
        arr.is_export = 1
        arr.yuanqu = store.getState().data.yuanqu ? store.getState().data.yuanqu : null
        let filename = ''
        fetch('/ProjectResource/list', {
            // post提交
            method: "POST", body: JSON.stringify(arr)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`请求失败，状态码: ${response.status}`);
                }
                filename = decodeURIComponent(response.headers.get('X-File-Name'));
                return response.blob();
            })
            .then(blob => {
                // console.log(blob)
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.target = '_blank';
                link.download = filename;
                link.click();
                window.URL.revokeObjectURL(url);
            })
            .catch(error => {
                console.error('下载文件时出错:', error);
            });
    }

    arrorder(arr, name) {
        if (arr) {
            return arr.map((item, index) =>
                <Menu.Item key={index}><a onClick={this.onOrderChange.bind(this, name, item.id)}
                    style={{ color: this.state.newcondition.order == item.id ? '#40a9ff' : '#333' }}>{item.name}</a></Menu.Item>
            )
        }
    }

    render() {
        const columns = [
            {
                title: '项目名称',
                dataIndex: 'title',
                key: 'title',
                // width: 200,
                // fixed: 'left',
                render: (row, record) => {
                    return (<>
                        <Space direction="vertical" size={0}>
                            <View id={record.id} title={row} refresh={this.getdata.bind(this)} />
                            {record.project_tags_text && record.project_tags_text.length > 0 ?
                                <Space wrap size={0}>
                                    {record.project_tags_text.map((item, index) => (
                                        <Tag key={index} color="blue">{item}</Tag>
                                    ))}
                                </Space>
                                : null}
                        </Space>
                    </>)
                },
            }, {
                title: '项目进度',
                dataIndex: 'project_progress_text',
                key: 'project_progress_text',
                width: 120,
                render: (row, record) => {
                    return <>
                        {record.project_progress == 1 ? <Tag color="blue">{row}</Tag> : null}
                        {record.project_progress == 2 ? <Tag color="green">{row}</Tag> : null}
                        {record.project_progress == 3 ? <Tag color="grey">{row}</Tag> : null}
                    </>
                },
            }, {
                title: '所属部门',
                dataIndex: 'bumen_id_text',
                key: 'bumen_id_text',
                width: 120,
            }, {
                title: '项目负责人',
                dataIndex: 'fzr_name',
                key: 'fzr_name',
                width: 120,
            },
            {
                title: '投资方（企业全称）',
                dataIndex: 'qy_name',
                key: 'qy_name',
                width: 250,
            }, {
                title: '面积',
                dataIndex: 'mianji',
                key: 'mianji',
                width: 120,
                sorter: true,
                sortOrder: this.state.newcondition.order_by == 'mianji' ? this.state.newcondition.order_type : null,
                render: (row, record) => {
                    return row + record.mianji_unit
                },
            }, {
                title: '拟投资额（万元）',
                dataIndex: 'touzi_price',
                key: 'touzi_price',
                width: 180,
                sorter: true,
                sortOrder: this.state.newcondition.order_by == 'touzi_price' ? this.state.newcondition.order_type : null,
            }, {
                title: '联系人',
                dataIndex: 'lxr_name',
                key: 'lxr_name',
                width: 120,
            }, {
                title: '联系电话',
                dataIndex: 'lxr_mobile',
                key: 'lxr_mobile',
                width: 150,
            },
            // {
            //     title: '资本类型',
            //     dataIndex: 'capital_type_text',
            //     key: 'capital_type_text',
            //     width: 100,
            // }, 
            {
                title: '国家/地区',
                dataIndex: 'address',
                key: 'address',
                width: 150,
            }, {
                title: '行业类别',
                dataIndex: 'industry_type',
                key: 'industry_type',
                width: 150,
            }, {
                title: '经济类别',
                dataIndex: 'economic_type_text',
                key: 'economic_type_text',
                width: 150,
            }, {
                title: '项目来源',
                dataIndex: 'origin_place',
                key: 'origin_place',
                width: 150,
            },{
                title: '中介/基金名称',
                dataIndex: 'fund_agency_name',
                key: 'fund_agency_name',
                width: 150,
            }, {
                title: '首次开拓时间',
                dataIndex: 'sckt_time',
                key: 'sckt_time',
                width: 120,
            }, {
                title: '添加人',
                dataIndex: 'aid_text',
                key: 'aid_text',
                width: 100,
            }, {
                title: '添加时间',
                dataIndex: 'addtime_text',
                key: 'addtime_text',
                width: 170,
            }, {
                title: '操作',
                dataIndex: 'cz',
                key: 'cz',
                align: 'center',
                fixed: 'right',
                width: 120,
                render: (row, record) => {
                    return (<>
                        <Space>
                            <View id={record.id} refresh={this.getdata.bind(this)} />
                            {store.getState().data.info.lmqx_bj ? (store.getState().data.info.lmqx_bj.includes('12') ?
                                <Edit refresh={this.getdata.bind(this)} id={record.id} />
                                : null) : null}
                        </Space>
                    </>)
                },
            },]
        const { tableloading, selectedRowKeys } = this.state;
        const rowSelection = {
            selectedRowKeys, onChange: this.onSelectChange.bind(this), // hideSelectAll: true,
            preserveSelectedRowKeys: false,
        };
        const hasSelected = selectedRowKeys.length > 0;
        return (<>
            <Row justify="space-between" wrap={false} align="top" gutter={[8, 8]} style={{ marginBottom: 15 }}>
                <Space wrap>
                    <Input className="input" placeholder="项目名称"
                        style={{ width: 150 }}
                        value={this.state.newcondition.title ? this.state.newcondition.title : null}
                        onChange={this.onChange.bind(this, 'title')} autoComplete="off" />
                    <Select placeholder="项目标签"
                        style={{ width: 250 }}
                        maxTagCount="responsive"
                        mode="multiple"
                        value={this.state.newcondition.project_tags ? this.state.newcondition.project_tags : []}
                        onChange={this.onSelChange.bind(this, 'project_tags')} allowClear>
                        {this.arrsel(this.state.project_tags_react)}
                    </Select>
                    <Select placeholder="项目进度"
                        style={{ width: 150 }}
                        value={this.state.newcondition.project_progress ? this.state.newcondition.project_progress : null}
                        onChange={this.onSelChange.bind(this, 'project_progress')} allowClear>
                        {this.arrsel(this.state.project_progress_react)}
                    </Select>
                    <Select placeholder="所属部门"
                        style={{ width: 150 }}
                        value={this.state.newcondition.bumen_id ? this.state.newcondition.bumen_id : null}
                        onChange={this.onSelChange.bind(this, 'bumen_id')} allowClear>
                        {this.arrsel(this.state.bumen_id_react)}
                    </Select>
                    <Input className="input" placeholder="项目负责人"
                        style={{ width: 150 }}
                        value={this.state.newcondition.fzr_name ? this.state.newcondition.fzr_name : null}
                        onChange={this.onChange.bind(this, 'fzr_name')} autoComplete="off" />
                    <Input className="input" placeholder="投资方"
                        style={{ width: 150 }}
                        value={this.state.newcondition.qy_name ? this.state.newcondition.qy_name : null}
                        onChange={this.onChange.bind(this, 'qy_name')} autoComplete="off" />
                    <Space size={5}>
                        <Input className="input" placeholder="面积"
                            value={this.state.newcondition.mianji1 ? this.state.newcondition.mianji1 : null}
                            onChange={this.onChange.bind(this, 'mianji1')} autoComplete="off" />
                        <span>~</span>
                        <Input className="input" placeholder="面积"
                            value={this.state.newcondition.mianji2 ? this.state.newcondition.mianji2 : null}
                            onChange={this.onChange.bind(this, 'mianji2')} autoComplete="off" />
                    </Space>
                    <Space size={5}>
                        <Input className="input" placeholder="拟投资额"
                            value={this.state.newcondition.touzi_price1 ? this.state.newcondition.touzi_price1 : null}
                            onChange={this.onChange.bind(this, 'touzi_price1')} autoComplete="off" />
                        <span>~</span>
                        <Input className="input" placeholder="拟投资额"
                            value={this.state.newcondition.touzi_price2 ? this.state.newcondition.touzi_price2 : null}
                            onChange={this.onChange.bind(this, 'touzi_price2')} autoComplete="off" />
                    </Space>
                    <Input className="input" placeholder="联系人"
                        style={{ width: 150 }}
                        value={this.state.newcondition.lxr_name ? this.state.newcondition.lxr_name : null}
                        onChange={this.onChange.bind(this, 'lxr_name')} autoComplete="off" />
                    <Input className="input" placeholder="联系电话"
                        style={{ width: 150 }}
                        value={this.state.newcondition.lxr_mobile ? this.state.newcondition.lxr_mobile : null}
                        onChange={this.onChange.bind(this, 'lxr_mobile')} autoComplete="off" />
                    <Input className="input" placeholder="国家/地区"
                        style={{ width: 150 }}
                        value={this.state.newcondition.address ? this.state.newcondition.address : null}
                        onChange={this.onChange.bind(this, 'address')} autoComplete="off" />
                    <Input className="input" placeholder="行业类别"
                        style={{ width: 150 }}
                        value={this.state.newcondition.industry_type ? this.state.newcondition.industry_type : null}
                        onChange={this.onChange.bind(this, 'industry_type')} autoComplete="off" />
                    <Select placeholder="经济类别"
                        style={{ width: 150 }}
                        value={this.state.newcondition.economic_type ? this.state.newcondition.economic_type : null}
                        onChange={this.onSelChange.bind(this, 'economic_type')} allowClear>
                        {this.arrsel(this.state.economic_type_react)}
                    </Select>
                    <Input className="input" placeholder="项目来源"
                        style={{ width: 150 }}
                        value={this.state.newcondition.origin_place ? this.state.newcondition.origin_place : null}
                        onChange={this.onChange.bind(this, 'origin_place')} autoComplete="off" />
                    <Input className="input" placeholder="中介/基金名称"
                        style={{ width: 150 }}
                        value={this.state.newcondition.fund_agency_name ? this.state.newcondition.fund_agency_name : null}
                        onChange={this.onChange.bind(this, 'fund_agency_name')} autoComplete="off" />
                    <RangePicker allowEmpty={[true, true]} onChange={this.onRangeChange.bind(this, 'sckt_time')}
                        style={{ width: 300 }}
                        value={[(this.state.newcondition.sckt_time1 ? moment(this.state.newcondition.sckt_time1) : null), (this.state.newcondition.sckt_time2 ? moment(this.state.newcondition.sckt_time2) : null)]}
                        placeholder={['首次开拓时间', '首次开拓时间']} />
                    <Input className="input" placeholder="添加人"
                        style={{ width: 150 }}
                        value={this.state.newcondition.aid_text ? this.state.newcondition.aid_text : null}
                        onChange={this.onChange.bind(this, 'aid_text')} autoComplete="off" />
                    <RangePicker allowEmpty={[true, true]} onChange={this.onRangeChange.bind(this, 'addtime')}
                        style={{ width: 300 }}
                        value={[(this.state.newcondition.addtime1 ? moment(this.state.newcondition.addtime1) : null), (this.state.newcondition.addtime2 ? moment(this.state.newcondition.addtime2) : null)]}
                        placeholder={['添加时间', '添加时间']} />
                    <Button type="primary" icon={<SearchOutlined />}
                        onClick={this.getdata.bind(this, 1)}>查询</Button>
                    <Button type="primary" icon={<ReloadOutlined />} className='huise'
                        onClick={this.reset.bind(this)}>重置</Button>
                </Space>
                {store.getState().data.info.lmqx_tj ? (store.getState().data.info.lmqx_tj.includes('12') ?
                    <Edit refresh={this.getdata.bind(this)} />
                    : null) : null}
            </Row>
            <Table
                bordered
                columns={columns}
                dataSource={this.state.list}
                pagination={false}
                loading={tableloading}
                rowSelection={rowSelection}
                className='table'
                scroll={{ x: 2800 }}
                style={{ marginBottom: 20 }}
                onChange={(pagination, filters, sorter) => {
                    // console.log(pagination, filters, sorter);
                    let that = this
                    let data = Object.assign({}, this.state.newcondition, { order_by: sorter.columnKey, order_type: sorter.order })
                    this.setState({
                        newcondition: data
                    })
                    setTimeout(() => {
                        that.getdata(1)
                    })
                }}
            />
            <Row justify={'space-between'}>
                <div className='l'>
                    <Space wrap >
                        {hasSelected ? <>
                            {store.getState().data.info.lmqx_sc ? (store.getState().data.info.lmqx_sc.includes('12') ?
                                <Popconfirm
                                    title="确认删除?"
                                    onConfirm={() => this.delSel()}
                                    okText="确认"
                                    cancelText="取消"
                                >
                                    <Button type="primary" danger>删除</Button>
                                </Popconfirm>
                                : null) : null}
                            {store.getState().data.info.lmqx_dc ? (store.getState().data.info.lmqx_dc.includes('12') ?
                                <Button type="primary"
                                    onClick={() => this.download(1)}>导出</Button> : null) : null}
                        </> : null}
                        {store.getState().data.info.lmqx_dc ? (store.getState().data.info.lmqx_dc.includes('12') ?
                            <Button type="primary" onClick={() => this.download()}>全部导出</Button>
                            : null) : null}

                        {hasSelected ?
                            <div style={{ color: 'orange', marginLeft: '10px' }}>面积总计：{this.state.selected_pingmi ? this.state.selected_pingmi : 0}平米，{this.state.selected_mu ? this.state.selected_mu : 0}亩，拟投资额总计：{this.state.selected_price ? this.state.selected_price : 0}万元</div>
                            :
                            <div style={{ color: 'orange', marginLeft: '10px' }}>面积总计：{this.state.mianji_pingmi ? this.state.mianji_pingmi : 0}平米，{this.state.mianji_mu ? this.state.mianji_mu : 0}亩，拟投资额总计：{this.state.total_touzi_price ? this.state.total_touzi_price : 0}万元</div>
                        }
                    </Space>
                </div>
                <Pagination showQuickJumper
                    current={this.state.oldcondition.current ? this.state.oldcondition.current : 1}
                    pageSize={this.state.oldcondition.pagesize ? this.state.oldcondition.pagesize : 10}
                    total={this.state.count} onChange={this.pagechange.bind(this)} showSizeChanger={true}
                    showTotal={total => `共 ${total} 条数据`} />
            </Row>
        </>)
    }
}

export default (props) => <Index {...props} key={props.location.pathname} />
